import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

/*
* 因有部分input比较大
*/

const BigPWDInput = (props) => {
  const { height = '.45rem', style } = props;

  const initStyle = {
    height,
    borderRadius: 5,
    minHeight: 30
  };

  return (
    <Input.Password
      {...props}
      style={{ ...initStyle, ...style }}
    />
  )
};

BigPWDInput.propTypes = {
  props: PropTypes.object
}

export default BigPWDInput;